<template>
    <v-container fluid fill-height grid-list-xs pa-0 :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-layout row wrap> <!--fluid fill-height row justify-center>-->
            <v-flex d-flex xs12 pa-0>
                <v-card class="fill-height flex-card">

                    <v-toolbar card prominent dense>
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    :disabled="!acl.Create || !calcEnabled"
                                    @click="calculate"
                                >
                                    <v-icon>mdi-calculator</v-icon>
                                    <span>{{ $t("calculate") }}</span>
                                </v-btn>
                            </template>
                            <span>{{ $t("calculate") }}</span>
                        </v-tooltip>

                        <!-- Кнопка печать-->
                        <v-tooltip
                            bottom
                            :disabled="true"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="printChart"
                                    :disabled="!acl.Export || $obj.isEmpty(pattern)"
                                >
                                    <v-icon>mdi-printer-outline</v-icon>
                                    <span>{{ $t("print") }}</span>
                                </v-btn>
                            </template>
                            <span >{{ $t("print") }}</span>
                        </v-tooltip>

                        <v-tooltip
                            bottom
                            :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    @click="tasksHistoryClick"
                                >
                                    <v-icon>mdi-history</v-icon>
                                    <span
                                        v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                    >{{ $t("history") }}</span>
                                </v-btn>
                            </template>
                            <span>{{ $t("history") }}</span>
                        </v-tooltip>


                        <!--
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    v-on="on"
                                    :disabled="!acl.Create"
                                    @click="showVolumesTable"
                                >
                                    <v-icon>mdi-calculator</v-icon> {{ $t("volumesTable") }}
                                </v-btn>
                            </template>
                            <span>{{ $t("volumesTable") }}</span>
                        </v-tooltip>
                        -->

                    </v-toolbar>

                    <v-card-text class="fill-height pa-0">
                        <v-container fluid fill-height grid-list-xs pa-0>
                            <v-layout row wrap>
                                <!-- Блок параметров -->
                                <v-flex xs5 lg3 d-flex pa-0>
                                    <v-sheet
                                        class="grey v-scrollable"
                                        :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                    >
                                        <v-expansion-panel v-model="leftPanel" readonly expand class="elevation-0" style="overflow-y: hidden;">
                                            <!-- Параметры брёвен -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <template v-slot:header>
                                                    <div class="subheading font-weight-black">{{ $t("logsParameters") }}</div>
                                                </template>
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row class="mb-1">
                                                            <v-flex xs12 d-flex>
                                                                <v-select
                                                                    return-object
                                                                    v-model="selectedSpecies"
                                                                    :items="speciesFiltered"
                                                                    item-text="speciesTranslated"
                                                                    :label="$t('speciesAlt')"
                                                                    v-if="speciesFiltered.length > 0"
                                                                ></v-select>
                                                                <v-alert
                                                                    type="warning"
                                                                    value="true"
                                                                    v-if="speciesLoaded && speciesFiltered.length == 0"
                                                                >{{ $t("noSpeciesSelectedWarning") }}</v-alert>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row>
                                                            <v-flex xs10>
                                                                <span class="pl-0">{{ $t("length") }}, {{ $t("m") }}</span>
                                                                <v-slider
                                                                    v-model="length"
                                                                    :min="1.0"
                                                                    :max="10.0"
                                                                    :step="0.1"
                                                                    class="pr-2 mt-0"
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs2 mt-2>
                                                                <v-text-field
                                                                    :value="length"
                                                                    @change="length = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.required, rules.length]"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row>
                                                            <span class="pl-0">{{ $t("curvature") }}, %</span>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex
                                                                shrink
                                                                style="width: 60px"
                                                            >
                                                                <v-text-field
                                                                    v-model="curvature[0]"
                                                                    class="mt-0"
                                                                    hide-details
                                                                    single-line
                                                                    type="number"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                ></v-text-field>
                                                            </v-flex>

                                                            <v-flex>
                                                                <v-range-slider
                                                                    v-model="curvature"
                                                                    :min="0"
                                                                    :max="2"
                                                                    :step="0.05"
                                                                    class="mx-2"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                ></v-range-slider>
                                                            </v-flex>

                                                            <v-flex
                                                                shrink
                                                                style="width: 60px"
                                                            >
                                                                <v-text-field
                                                                    v-model="curvature[1]"
                                                                    class="mt-0"
                                                                    hide-details
                                                                    single-line
                                                                    type="number"
                                                                    :disabled="$store.getters.subscription.settings.optimization.lockCurvature"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row>
                                                            <v-flex xs10>
                                                                <span class="pl-0">{{ $t("averageTaper") }}, {{ $t("mm")}}/{{ $t("m") }}</span>
                                                                <v-slider
                                                                    v-model="taper"
                                                                    :min="1"
                                                                    :max="50"
                                                                    :disabled="autoTaper"
                                                                    class="pr-2 mt-0"
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs2 mt-2>
                                                                <v-text-field
                                                                    :value="taper"
                                                                    @change="taper = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.requiredNumAllowZero, rules.taper]"
                                                                    :disabled="autoTaper"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <table class="dense param-table w-100">
                                                            <tbody>
                                                                <tr>
                                                                    <td>{{ $t("automaticallyCalculateTaper") }}</td>
                                                                    <td>
                                                                        <v-checkbox v-model="autoTaper"></v-checkbox>
                                                                    </td>
                                                                </tr>
                                                                <tr><td colspan="2"></td></tr>
                                                            </tbody>
                                                        </table>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>

                                            <!-- Параметры досок -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <template v-slot:header>
                                                    <div class="subheading font-weight-black">{{ $t("boardsParameters") }}</div>
                                                </template>
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">

                                                        <v-layout row>
                                                            <v-flex xs10>
                                                                <span class="pl-0">{{ $t("minimalLength") }}, {{ $t("m") }}</span>
                                                                <v-slider
                                                                    v-model="minBoardLength"
                                                                    :min="1.0"
                                                                    :max="length"
                                                                    :step="0.1"
                                                                    class="pr-2 mt-0"
                                                                ></v-slider>
                                                            </v-flex>
                                                            <v-flex xs2 mt-2>
                                                                <v-text-field
                                                                    :value="minBoardLength"
                                                                    @change="minBoardLength = $event"
                                                                    class="mt-0"
                                                                    type="number"
                                                                    :rules="[rules.required, rules.minBoardLength]"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>

                                            <!-- Поставы -->
                                            <v-expansion-panel-content
                                                hide-actions
                                                class="grey"
                                                :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                            >
                                                <!-- <template v-slot:header>
                                                    <div class="subheading font-weight-black">{{ $t("patterns") }}</div>
                                                </template> -->
                                                <v-card
                                                    class="grey"
                                                    :class="{'lighten-4': !theme.isDark, 'darken-4': theme.isDark}"
                                                >
                                                    <v-card-text class="dense">
                                                        <v-layout row align-center pl-2 pt-2>
                                                            <div class="subheading font-weight-black">{{ $t("patterns") }}</div>
                                                            <v-btn icon flat small @click="$router.replace({ path: '/patterns' })">
                                                                <v-icon>mdi-cogs</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                        <template>
                                                            <v-data-table
                                                                item-key="id"
                                                                :headers="computedHeaders"
                                                                :items="filteredData"
                                                                :rows-per-page-items="[100]"
                                                                hide-actions
                                                                class="dense-table pb-2"
                                                            >
                                                                <template v-slot:items="props">
                                                                    <tr
                                                                        @click="showPattern(props.item)"
                                                                        :class="{'grey darken-5': props.item.id == selectedPattern.id}"
                                                                    >
                                                                        <!--
                                                                        <td>{{ props.item.speciesTranslated }}</td>
                                                                        -->
                                                                        <td class="text-xs-right">{{ props.item.Du }}</td>
                                                                        <td>{{ props.item.name }}</td>
                                                                        <td class="text-xs-right">{{ props.item.updatedAt }}</td>
                                                                    </tr>
                                                                </template>
                                                            </v-data-table>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-sheet>
                                </v-flex>
                                <!-- /Блок параметров -->

                                <!-- Блок отображение постава -->
                                <v-flex xs7 lg4 d-flex pa-0>
                                    <v-sheet class="v-scrollable" style="border-right: 1px dotted">
                                        <v-container grid-list-md class="printable pattern-wrapper v-scrollable">
                                            <v-layout wrap>
                                                <!--
                                                <v-sheet
                                                    class="d-flex pattern-container"
                                                    xs12 lg6
                                                    id="pattern_preview1"
                                                    elevation="5"
                                                >
                                                </v-sheet>
                                                -->
                                                <v-sheet
                                                    class="d-flex pattern-container"
                                                    xs12
                                                    id="pattern_preview"
                                                    elevation="0"
                                                    ref="PatternPreview"
                                                >
                                                    <div ref="Pattern">
                                                        <pattern-vue
                                                            :pattern="pattern"
                                                            :sizeNominal="sizeNominal"
                                                            :falseCore="falseCore"
                                                            :ellipseRatio="0"
                                                            :rotate="0"
                                                            :showDiameter="true"
                                                            :showCross="false"
                                                            :patternSolidBG="patternSolidBG"
                                                            :rotatePattern="rotatePattern"
                                                            sideSize="350"
                                                            ref="PatternVue"
                                                        />
                                                    </div>
                                                </v-sheet>
                                                <v-sheet
                                                    class="d-flex ml-4 mt-2"
                                                    xs12 lg6
                                                >
                                                    <div v-if="this.selectedPattern.name !== ''">
                                                        <p v-if="this.optimalDiam != 0">
                                                            <b>{{ $t("optimalDiameter") }}:</b> {{ this.optimalDiam }} {{ this.$t("mm") }}
                                                        </p>
                                                        <p v-if="this.optimalOutput != 0">
                                                            <b>{{ $t("output") }}:</b> {{ this.optimalOutput.toFixed(2) }} %
                                                        </p>

                                                        <p><b>{{ $t("name") }}:</b> {{ this.selectedPattern.name }}</p>
                                                        <p><b>{{ $t("speciesAlt") }}:</b> {{ this.selectedPattern.speciesTranslated }}</p>
                                                        <!--<p><b>{{ $t("diameterU") }}:</b> {{ this.selectedPattern.Du }} {{ this.$t("cm") }}</p>-->
                                                        <p><b>{{ $t("createModifyDate") }}:</b> {{ this.selectedPattern.updatedAt ? this.selectedPattern.updatedAt : "" }}</p>
                                                    </div>
                                                </v-sheet>
                                            </v-layout>
                                        </v-container>

                                        <v-toolbar card prominent dense>{{ $t("showSizes") }}&nbsp;
                                            <v-radio-group v-model="sizeNominal" hide-details row>
                                                <v-radio :value="1" :label="$t('nominalSizes')"></v-radio>
                                                <v-radio :value="0" :label="$t('actualSizes')"></v-radio>
                                            </v-radio-group>
                                            <!--
                                            <v-spacer></v-spacer>
                                            <v-switch class="mt-4" :label="$t('rotatePattern')" v-model="rotatePattern"></v-switch>
                                            -->
                                        </v-toolbar>

                                    </v-sheet>
                                </v-flex>
                                <!-- /Блок отображение постава -->

                                <!-- Блок графиков -->
                                <v-flex xs12 pa-0 v-if="$vuetify.breakpoint.mdAndDown">
                                    <v-toolbar card prominent dense>
                                     </v-toolbar>
                                </v-flex>
                                <v-flex xs12 lg5 pa-0>
                                    <v-sheet class="v-scrollable-chart">
                                        <v-container fluid class="py-1">
                                            <v-card flat>
                                                <!--
                                                <v-card-title class="py-0"><h3>{{ $t("distribution") }}</h3></v-card-title>
                                                @highlight="onChartHighlight"
                                                -->
                                                <v-card-text class="pa-0">
                                                    <chart-vue :options="chartOptions" setTheme="auto" class="chart" ref="Chart"></chart-vue>
                                                </v-card-text>
                                            </v-card>
                                        </v-container>
                                    </v-sheet>

                                    <v-toolbar card prominent dense>
                                        <template v-if="showSettings">{{ $t("settings") }}</template>
                                        <v-radio-group v-model="diamsTable" hide-details row v-if="!showSettings">
                                            <v-radio class="caption" small :label="$t('noCurvature')" value="0"></v-radio>
                                            <v-radio class="caption" small :label="$t('minCurvature')" value="1"></v-radio>
                                            <v-radio class="caption" small :label="$t('maxCurvature')" value="2"></v-radio>
                                        </v-radio-group>
                                        <v-spacer></v-spacer>
                                        <v-btn fab flat small @click="showSettings=!showSettings"><v-icon>mdi-cog-outline</v-icon></v-btn>
                                    </v-toolbar>

                                    <v-sheet class="v-scrollable-table">
                                        <v-card v-if="showSettings">
                                            <v-card-text>
                                                <v-layout row>
                                                    <v-flex xs10 sm11>
                                                        <span class="pl-0">{{ $t("outputDeltaForCalculatingOptimalDiamRange") }}</span>
                                                        <v-slider
                                                            v-model="diamStep"
                                                            :min="0.5"
                                                            :max="5"
                                                            :step="0.5"
                                                            ticks="always"
                                                            class="pr-2 mt-0"
                                                        ></v-slider>
                                                    </v-flex>
                                                    <v-flex xs2 sm1 mt-2>
                                                        <v-text-field
                                                            :value="diamStep"
                                                            @change="diamStep = $event"
                                                            class="mt-0"
                                                            type="number"
                                                            prefix="-"
                                                            suffix="%"
                                                            :rules="[rules.required, rules.diamStep]"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                            <v-divider></v-divider>
                                            <v-card-text>
                                                {{ $t("tableData") }}:&nbsp;
                                                <v-radio-group v-model="showAllData" hide-details row>
                                                    <v-radio :label="$t('fullRange')" :value="true"></v-radio>
                                                    <v-radio :label="$t('optimalDiametersRange')" :value="false"></v-radio>
                                                </v-radio-group>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-btn block color="success" @click="showSettings = false">{{ $t("close") }}</v-btn>
                                            </v-card-actions>
                                        </v-card>

                                        <table class="simple-data-table w-100 caption" dense v-if="!showSettings">
                                            <thead>
                                                <tr>
                                                    <th>{{ $t("diameter") }}</th>
                                                    <th>{{ $t("boards") }}</th>
                                                    <th>{{ $t("amount") }}</th>
                                                    <th>{{ $t("logVolume") }}, {{ $t("m3")}}</th>
                                                    <th>{{ $t("boardsVolume") }}, {{ $t("m3")}}</th>
                                                    <th>{{ $t("output") }}, %</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="diamsTable == 0">
                                                <template v-for="(item, index) in tableData.noCurvature">
                                                    <template v-for="(subItem, subIndex) in item.dimensions">
                                                        <tr
                                                            :key="`${index}-${subIndex}`"
                                                            v-if="showAllData || (parseInt(item.D) >= parseInt(diamsRange[0]) && parseInt(item.D) <= parseInt(diamsRange[1]))"
                                                        >
                                                            <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{item.D}}</td>
                                                            <td class="px-2">{{subItem}}</td>
                                                            <td class="text-xs-right px-2">{{item.amount[subIndex]}}</td>
                                                            <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.logV).toFixed(3)}}</td>
                                                            <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.boardsV).toFixed(3)}}</td>
                                                            <td class="text-xs-right px-2 pr-3" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.output).toFixed(1)}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </tbody>
                                            <tbody v-if="diamsTable == 1">
                                                <template v-for="(item, index) in tableData.minCurvature">
                                                    <template v-for="(subItem, subIndex) in item.dimensions">
                                                        <tr
                                                            :key="`${index}-${subIndex}`"
                                                            v-if="showAllData || (parseInt(item.D) >= parseInt(diamsRange[0]) && parseInt(item.D) <= parseInt(diamsRange[1]))"
                                                        >
                                                            <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{item.D}}</td>
                                                            <td class="px-2">{{subItem}}</td>
                                                            <td class="text-xs-right px-2">{{item.amount[subIndex]}}</td>
                                                            <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.logV).toFixed(3)}}</td>
                                                            <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.boardsV).toFixed(3)}}</td>
                                                            <td class="text-xs-right px-2 pr-3" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.output).toFixed(1)}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </tbody>
                                            <tbody v-if="diamsTable == 2">
                                                <template v-for="(item, index) in tableData.maxCurvature">
                                                    <template v-for="(subItem, subIndex) in item.dimensions">
                                                        <tr
                                                            :key="`${index}-${subIndex}`"
                                                            v-if="showAllData || (parseInt(item.D) >= parseInt(diamsRange[0]) && parseInt(item.D) <= parseInt(diamsRange[1]))"
                                                        >
                                                            <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{item.D}}</td>
                                                            <td class="px-2">{{subItem}}</td>
                                                            <td class="text-xs-right px-2">{{item.amount[subIndex]}}</td>
                                                            <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.logV).toFixed(3)}}</td>
                                                            <td class="text-xs-right px-2" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.boardsV).toFixed(3)}}</td>
                                                            <td class="text-xs-right px-2 pr-3" v-if="subIndex == 0" :rowspan="[item.amount.length]">{{parseFloat(item.output).toFixed(1)}}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </tbody>
                                        </table>
                                    </v-sheet>
                                </v-flex>
                                <!-- /Блок графиков -->

                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>

            <diam-print-dialog    ref="DiamPrintDialog"/>
            <message-box          ref="MessageBox"/>
            <tasks-history-dialog ref="TasksHistoryDialog"/>

        </v-layout>
    </v-container>
</template>

<script>
    //import * as echarts       from "echarts";
    import ChartVue           from "@/components/ChartVue";
    import DiamPrintDialog    from "@/components/dialogs/DiamPrintDialog";
    import MessageBox         from "@/components/dialogs/MessageBox";
    import PatternVue         from "@/components/patterns/PatternVue";
    import TasksHistoryDialog from "@/components/dialogs/TasksHistoryDialog";

    export default {
        name: "DiamOptimization",

        inject: ["theme"],

        components: {
            ChartVue,
            DiamPrintDialog,
            MessageBox,
            PatternVue,
            TasksHistoryDialog
        },

        data () {
            return {
                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },

                breadCrumbs: [
                    { text: "Поиск оптимального диаметра", disabled: false }
                ],

                calculatedTableHeader: [
                    { text: "Сечение",   align: "left", value: "size",   sortable: false },
                    { text: "Длина, м",  align: "left", value: "length", sortable: false },
                    { text: "Кол-во",    align: "left", value: "qty",    sortable: false },
                    { text: "Объем, м3", align: "left", value: "volume", sortable: false },
                    { text: "% выхода",  align: "left", value: "percent",sortable: false },
                ],
                calculatedTableData: [],

                headers: [
                    { text: "id",                      value: "id",        align: "left",  sortable: false },
                    { text: "speciesId",               value: "speciesId", align: "left",  sortable: false },
                    { text: "dataJSON",                value: "dataJSON",  align: "left",  sortable: false },
                    { text: "Порода",                  value: "species",   align: "left",  sortable: true },
                    { text: "Учетный диаметр",         value: "Du",        align: "left",  sortable: true },
                    { text: "Имя",                     value: "name",      align: "left",  sortable: true },
                    { text: "Дата создания/изменения", value: "modDate",   align: "right", sortable: true }
                ],

                rules: {
                    minBoardLength: value => (value >= 0 && value <= this.length) || this.$t("incorrectValue"),
                    requiredNumAllowZero: value => (!!value || value == 0) || this.$t("requiredField"),
                    required: value => !!value || this.$t("requiredField"),
                    length:   value => (value >= 0 && value <= 10) || this.$t("incorrectValue"),
                    taper:    value => (value >= 1 && value <= 200) || this.$t("incorrectValue"),
                    diamStep: value => (value >= 0.5 && value <= 5) || this.$t("incorrectValue"),
                },

                loading: {
                    calculationResult: false,
                    patterns:          false,
                    species:           false
                },

                leftPanel:       [true, true, true],
                dialogWatcher:   null,

                calcTimestamp:   null,

                autoTaper:       true,
                hideIDs:         true,
                patterns:        [],
                pattern:         {},
                selectedPattern: {
                    name:      "",
                    species:   "",
                    Du:        0,
                    updatedAt: ""
                },
                sizeNominal:     1,
                falseCore:       false,
                rotatePattern:   false,
                patternSolidBG:  false,

                diamsRange:      [0, 0],
                diamStep:        1,
                optimalDiam:     0,
                optimalOutput:   0,
                curvature:       [0, 0],
                length:          4,
                taper:           1,
                species:         [],
                speciesLoaded:   false,
                minBoardLength:  3,
                selectedSpecies: { id: 0, species: "", speciesTranslated: "" },

                diamsTable:      "0",
                tableData: {
                    noCurvature:  [],
                    minCurvature: [],
                    maxCurvature: []
                },

                showSettings: false,
                showAllData:  true,

                chart:        null,
                chartOptions: {},
                series:       [],
            }
        },

        async mounted () {
            if (!this.$store.getters.user.loggedIn) {
                localStorage.routerPath = "/optimization";
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            if (this.$store.getters.user.acl) {
                this.$store.getters.user.acl.forEach((aclRecord) => {
                    if (aclRecord.Module.Name == "calc") {
                        this.acl = aclRecord;
                    } else if (aclRecord.Module.Name == "patterns") {
                        this.aclPatterns = aclRecord;
                    }
                });
            }

            this.patternSolidBG = this.$store.getters.user !== undefined
                && this.$store.getters.user.settings !== undefined
                && this.$store.getters.user.settings.patternSolidBG !== undefined
                && this.$store.getters.user.settings.patternSolidBG;

            this.rotatePattern = this.$store.getters.user !== undefined
                && this.$store.getters.user.settings !== undefined
                && this.$store.getters.user.settings.rotatePattern !== undefined
                && this.$store.getters.user.settings.rotatePattern;

            this.autoTaper      = localStorage.opt2AutoTaper  ? JSON.parse(localStorage.opt2AutoTaper) : true;
            this.curvature      = localStorage.opt2Curvature  ? JSON.parse(localStorage.opt2Curvature) : [0.3, 1.2];
            this.diamStep       = localStorage.opt2DiamStep       ? localStorage.opt2DiamStep : 1;
            this.diamsTable     = localStorage.opt2DiamsTable     ? localStorage.opt2DiamsTable : "0";
            this.length         = localStorage.opt2OptDLogLength  ? localStorage.opt2OptDLogLength : 4;
            this.minBoardLength = localStorage.opt2MinBoardLength ? localStorage.opt2MinBoardLength : 3;
            this.taper          = localStorage.opt2OptDTaper      ? localStorage.opt2OptDTaper : 1;
            this.sizeNominal    = localStorage.sizeNominal    ? parseInt(localStorage.sizeNominal) : 1;
            this.showAllData    = localStorage.opt2ShowFullOptimalDiamsRange ? JSON.parse(localStorage.opt2ShowFullOptimalDiamsRange) : true;

            this.applyLocale();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            this.loadSpecies();
            this.loadPatterns();

            if (this.$store.getters.subscription.settings.optimization.lockCurvature) {
                this.curvature = [0, 0];
                localStorage.curvature = [0, 0];
            }
        },

        watch: {
            autoTaper:      function (val) { localStorage.opt2AutoTaper  = val; },
            curvature:      function (val) { localStorage.opt2Curvature  = JSON.stringify(val); },
            diamsTable:     function (val) { localStorage.opt2DiamsTable     = val; },
            length:         function (val) { localStorage.opt2OptDLogLength  = val; },
            minBoardLength: function (val) { localStorage.opt2MinBoardLength = val; },
            taper:          function (val) { localStorage.opt2OptDTaper      = val; },
            showAllData:    function (val) { localStorage.opt2ShowFullOptimalDiamsRange = val; },
            sizeNominal:    function (val) { localStorage.sizeNominal = val; },
            diamStep: function (val) {
                localStorage.diamStep = val;
                this.drawChart();
            },
        },

        computed: {
            calcEnabled () {
                return this.selectedSpecies.id !== 0 && this.selectedPattern.id !== undefined;
            },

            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(
                        header => header.text !== "id"
                            && header.text  !== "speciesId"
                            && header.value !== "species"
                            && header.text  !== "dataJSON"
                    );
                }

                return this.headers;
            },

            filteredData () {
                return this.patterns.filter(pattern => pattern.species == this.selectedSpecies.species); // || this.selectedSpecies == null);
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.calculationResult || this.loading.patterns || this.loading.species;
            },

            speciesFiltered () {
                return this.species.filter(item => this.$store.getters.user.settings.selectedSpecies.includes(item.id))
            },
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("findingTheOptimalDiameter"), disabled: false }
                ];

                this.headers = [
                    { text: "id",                  value: "id",        align: "left",   sortable: false },
                    { text: "speciesId",           value: "speciesId", align: "left",   sortable: false },
                    { text: "dataJSON",            value: "dataJSON",  align: "left",   sortable: false },
                    { text: this.$t("speciesAlt"), value: "species",   align: "left",   sortable: true },
                    {
                        text: this.$t("diameterShort") + ", " + this.$t("cm"),
                        value: "Du",
                        align: "left",
                        sortable: true
                    },
                    //{ text: this.$t("diameterU"),        value: "Du",        align: "left",   sortable: true },
                    { text: this.$t("name"),       value: "name",      align: "left",  sortable: true },
                    { text: this.$t("modified"),   value: "modDate",   align: "right", sortable: true } //,
                    //{ text: this.$t("action"),           value: "action",    align: "center", sortable: false }
                ];

                this.calculatedTableHeader = [
                    { text: this.$t("dimension"),                     align: "left",  value: "size",    sortable: false },
                    { text: `${this.$t("length")}, ${this.$t("m")}`,  align: "left",  value: "length",  sortable: false },
                    { text: this.$t("amountShort"),                   align: "left",  value: "qty",     sortable: false },
                    { text: `${this.$t("volume")}, ${this.$t("m3")}`, align: "left",  value: "volume",  sortable: false },
                    { text: `${this.$t("output")}`,                   align: "left",  value: "percent", sortable: false },
                ];

                this.drawChart();
            },

            /**
             * Выполнение расчёта
             */
            calculate () {
                this.loading.calculationResult = true;

                let pattern     = this.$refs.PatternVue.getPattern();
                pattern.name    = this.selectedPattern.name;
                pattern.du      = this.selectedPattern.Du;
                pattern.species = this.selectedPattern.speciesTranslated;
                pattern.date    = this.selectedPattern.updatedAt ? this.selectedPattern.updatedAt : "";

                let task = {
                    speciesId: parseInt(this.selectedSpecies.id),
                    l:         this.length,
                    taper:     this.autoTaper ? 0 : this.taper,
                    curvature: this.curvature,
                    patternId: this.selectedPattern.id,
                    pattern:   pattern,
                    minBoardL: this.minBoardLength,
                };

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}tasks/`,
                    data: {
                        type:     2,    // 1 - Оптимизация раскроя, 2 - Поиск оптимального диаметра, 3 - пересчёт постава
                        dataJSON: JSON.stringify(task)
                    },
                    withCredentials: true
                }).then(response => {
                    this.loading.calculationResult = false;
                    this.callExternalApp(response.data.task.id);
                }).catch(err => {
                    this.$debug.error(err);

                    this.loading.calculationResult = false;

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `DiamOptimization.vue -> calculate: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        this.$debug.error(error);

                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    if (err.response && err.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => {  window.location.reload(); }
                        );
                    } else if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (
                        err.response && err.response.status == 403
                        && typeof err.response.data !== "object"
                        && err.response.data.trim() == "Access denied. Session id mismatch"
                    ) {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("calculationError"));
                    }
                });
            },

            /**
             * Вызов внешнего приложения
             *
             * @param {number} taskId Идентификатор задачи
             */
            callExternalApp(taskId) {
                this.loading.calculationResult = true;

                this.clearData();

                this.axios.get(`${this.$config.apiURL}calc/?task=${taskId}`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let responseData = JSON.parse(response.data.task.ResponseJSON);

                            if (responseData.error !== undefined) { // && responseData.error == "unsupportedPattern") {
                                throw responseData.error;
                            }

                            /*
                            if (responseData.error) {
                                this.showError(responseData);
                                this.resetData();
                                this.loading.calculationResult = false;
                                return;
                            }
                            */

                            this.tableData = {
                                noCurvature:  [],
                                minCurvature: [],
                                maxCurvature: []
                            },

                            responseData.tablesData.forEach(table => {
                                if (table.name == "noCurv") {
                                    this.tableData.noCurvature = table.data;
                                }
                                if (table.name == "minCurv") {
                                    this.tableData.minCurvature = table.data;
                                }
                                if (table.name == "maxCurv") {
                                    this.tableData.maxCurvature = table.data;
                                }
                            });

                            this.series = responseData.series;

                            this.calcTimestamp = new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString();
                            this.drawChart();

                            this.calculatedTableData = [];

                            if (responseData.optimalPattern != undefined) {

                                let component  = this;
                                let boardsAmount = 0;
                                let outputVol = 0;

                                this.optimalDiam = responseData.optimalPattern.D;
                                this.optimalOutput = responseData.optimalPattern.output;

                                responseData.optimalPattern.dimensions.forEach((item, index) => {

                                    let size = item.split("-")[0].split("x");
                                    let len = item.split("-")[1].replace(",",".");
                                    let vol = (parseFloat(size[0])/1000) * (parseFloat(size[1])/1000) * parseFloat(len) * responseData.optimalPattern.amount[index];
                                    outputVol += vol;
                                    boardsAmount += responseData.optimalPattern.amount[index];

                                    component.calculatedTableData.push({
                                        size:       item.split("-")[0],
                                        length:     len,
                                        volume:     vol.toFixed(3),
                                        percent:    (vol / responseData.optimalPattern.logV * 100).toFixed(2).toString(),
                                        qty:        responseData.optimalPattern.amount[index]
                                    });
                                });

                                this.calculatedTableData.push({
                                    size:       "",
                                    length:     "",
                                    volume:     outputVol.toFixed(3).toString(),
                                    percent:    responseData.optimalPattern.output.toFixed(2).toString(),
                                    qty:        "(" + (boardsAmount).toString() + ")"
                                });
                                this.calculatedTableData.push({
                                    size:       "",
                                    length:     "",
                                    volume:     responseData.optimalPattern.dustVol.toFixed(3).toString(),
                                    percent:    (responseData.optimalPattern.dustVol / responseData.optimalPattern.logV * 100).toFixed(2).toString(),
                                    qty:        this.$t("sawdust")
                                });
                                this.calculatedTableData.push({
                                    size:       "",
                                    length:     "",
                                    volume:     responseData.optimalPattern.chipsVol.toFixed(3).toString(),
                                    percent:    (responseData.optimalPattern.chipsVol / responseData.optimalPattern.logV * 100).toFixed(2).toString(),
                                    qty:        this.$t("woodChips")
                                });
                                this.calculatedTableData.push({
                                    size:       "",
                                    length:     "",
                                    volume:     responseData.optimalPattern.logV.toFixed(3).toString(),
                                    percent:    "",
                                    qty:        this.$t("rawMaterials"),
                                });
                            }
                        }

                        this.loading.calculationResult = false;
                    })
                    .catch(err => {
                        this.$debug.error(err);

                        this.loading.calculationResult = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `DiamOptimization.vue -> callExternalApp: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            this.$debug.error(error);

                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (typeof err == "string") {
                            let errDescription = err == "unsupportedPattern" ? ". " + this.$t("unsupportedPatternInfo") : "";

                            //this.showMessageBox(this.$t("information"), this.$t(err) + errDescription);
                            if (err == "unsupportedPattern") {
                                this.showMessageBox(this.$t(err), this.$t("unsupportedPatternInfo"));
                            } else {
                                this.showMessageBox(this.$t("information"), this.$t(err) + errDescription);
                            }
                        } else if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("applicationError"));
                        }
                    });
            },

            /**
             * Очистка данных
             *
             * @param {bool} clearPattern Очищать данные постава
             */
            clearData (clearPattern = false) {

                this.optimalDiam = 0;
                this.optimalOutput = 0;

                if (clearPattern) { this.pattern = {}; }

                this.tableData = {
                    noCurvature:  [],
                    minCurvature: [],
                    maxCurvature: []
                };

                this.$refs.Chart.clear();
            },

            /**
             * Отрисовка графика
             */
            drawChart () {
                let maxPoint     = 0;
                let maxData      = 0;
                let minTotalData = 100;
                let maxTotalData = 0;
                let range        = [-100, 100];
                let data         = [ [], [], [], [] ];

                this.series.forEach((seriesData) => {
                    if (seriesData.name == "noCurv") {
                        data[0] = seriesData.data;
                    } else if (seriesData.name == "minCurv") {
                        data[1] = seriesData.data;
                    } else if (seriesData.name == "maxCurv") {
                        data[2] = seriesData.data;
                    } else if (seriesData.name == "avgCurv") {
                        data[3] = seriesData.data;
                    }

                    seriesData.data.forEach(item => {
                        item[1] = parseFloat(item[1]).toFixed(1);
                        if (parseFloat(item[1]) > parseFloat(maxTotalData)) { maxTotalData = item[1]; }
                        if (parseFloat(item[1]) < parseFloat(minTotalData)) { minTotalData = item[1]; }
                    });
                });

                data[3].forEach((item, index) => {
                    if (maxData < item[1]) {
                        maxData  = item[1];
                        maxPoint = index;
                    }
                });

                /*
                data.forEach((item, index) => {
                    if (range[0] == -100 && maxData - 2 >= item[1]) {
                        range[0] = index;
                    }
                });
                */

                range = [maxPoint, maxPoint];
                for (let i = maxPoint; i >= 0; i--) {
                    if (data[3].length == 0) {
                        break;
                    }
                    if (maxData - this.diamStep <= parseFloat(data[3][i][1])) {
                        range[0] = i;
                    } else {
                        break;
                    }
                }
                for (let i = maxPoint; i < data[3].length; i++) {
                    if (data[3].length == 0) {
                        break;
                    }
                    if (maxData - this.diamStep <= data[3][i][1]) {
                        range[1] = i;
                    } else {
                        break;
                    }
                }

                this.diamsRange = [
                    data[3].length > 0 ? data[3][range[0]][0] : 0,
                    data[3].length > 0 ? data[3][range[1]][0] : 0
                ];

                this.chartOptions = {
                    //backgroundColor: "#212121",
                    /*
                    title: {
                        text: this.$t("distribution")
                    },
                    */
                    grid: {
                        color: "#fff"
                    },
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        data: [ this.$t("noCurvature"), this.$t("minCurvature"), this.$t("maxCurvature"), this.$t("avgCurvature") ]
                    },
                    /*
                    grid: {
                        //left: "3%",
                        right: "14%",
                        //bottom: "3%",
                        containLabel: true
                    },
                    */
                    xAxis: [
                        {
                            type: "category",
                            name: "D", //this.$t("diameter"),
                            /* Вариант 1
                            data: [
                                "100", "101", "102", "103", "104", "105", "106", "107", "108", "109",
                                "110", "111", "112", "113", "114", "115", "116", "117", "118", "119",
                                "120", "121", "122", "123", "124", "125", "126", "127", "128"
                            ],
                            */
                        }
                    ],
                    yAxis:[
                        {
                            type: "value",
                            name: `${this.$t("output")}, %`,
                            min: minTotalData > this.diamStep
                                ? parseFloat(minTotalData - 3).toFixed(1)
                                : 0, //(value) => { return value = 40 },
                            max: maxTotalData < 100 - this.diamStep
                                ? parseFloat(maxTotalData + 3).toFixed(1)
                                : 100 //(value) => { return value = 45 }
                        }
                    ],
                    visualMap: {
                        type: "piecewise",
                        show: true,
                        dimension: 0,
                        seriesIndex: 3,
                        pieces: [
                            /*
                            {
                                gt: 0,
                                lt: range[0],
                                color: "#fff",
                            },
                            */
                            {
                                gt: range[0],
                                lt: range[1],
                                color: "#96ff9a",
                                label: this.diamsRange[0] > 0 && this.diamsRange[1] > 0
                                    ? `${this.$t("optimalDiametersRange")}: ${this.diamsRange[0]} - ${this.diamsRange[1]} ${this.$t("mm")}`
                                    : this.$t("optimalDiametersRange")
                                /*
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color:  "#96ff9a" //"#00d907"
                                    },
                                    {
                                        offset: 1,
                                        color: "#00d907"// "#005503"
                                    }
                                ])
                                */
                            },
                            /*
                            {
                                gt: range[1],
                                lt: range.length,
                                color: "#fff",
                            },
                            */
                        ],
                    },
                    series: [
                        {
                            name: this.$t("noCurvature"),
                            type:   "line",
                            smooth: true,
                            data: data[0]
                        },
                        {
                            name:   this.$t("minCurvature"),
                            type:   "line",
                            smooth: true,
                            data:   data[1]
                        },
                        {
                            name:   this.$t("maxCurvature"),
                            type:   "line",
                            smooth: true,
                            lineStyle: {
                                color: "#ff0000",
                                width: 2
                            },
                            itemStyle: {
                                borderColor: "#ff0000",
                                color: "#990000"
                            },
                            data:   data[2]
                        },
                        {
                            name: this.$t("avgCurvature"),
                            /* вариант 1
                            data: [ 0, 50, 150, 450, 500, 250, 100, 25, 20, 10, 10, 10, 5, 5, 0, 0,
                                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ],
                            */
                            type:   "line",
                            smooth: true,
                            /*
                            showSymbol: true,
                            symbol: "circle",
                            symbolSize: 2,
                            */
                            lineStyle: {
                                color: "#287f2b",
                                width: 2
                            },
                            markLine: {
                                symbol: ["none", "none"],
                                //color: "#fff",
                                label: { show: false },
                                data: [ { xAxis: range[0] }, { xAxis: range[1] }, { xAxis: maxPoint } ]
                            },
                            markPoint: {
                                data: [
                                    { type: "max", name: "Max" },
                                    //{ type: 'min', name: 'Min' }
                                ]
                            },
                            itemStyle: {
                                borderColor: "#287f2b",
                                color: "#287f2b" //this.$store.getters.user.settings.darkTheme ? "#287f2b" : "#005503" //"#39853c" //"#005503"
                            },
                            areaStyle: {
                                /*
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color:  "#96ff9a" //"#00d907"
                                    },
                                    {
                                        offset: 1,
                                        color: "#00d907"// "#005503"
                                    }
                                ])
                                */
                            },
                            data: data[3]
                        }
                    ]
                }

            },

            /**
             * Получение результатов задания на расчёт
             *
             * @param {number} id Идентификатор задания
             */
            getTaskResult (id) {
                this.loading.calculationResult = true;

                this.clearData(true);

                this.axios.get(`${this.$config.apiURL}tasks/${id}/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let requestData  = JSON.parse(response.data.task.RequestJSON);
                            let responseData = JSON.parse(response.data.task.ResponseJSON);
                            //let createdAt    = response.data.task.createdAt;
                            //let updatedAt    = new Date(response.data.task.updatedAt).toLocaleDateString()
                            //    + " " + new Date(response.data.task.updatedAt).toLocaleTimeString();

                            if (responseData == null) {
                                throw "optimizerResponseIsNull";
                            } else if (responseData.error !== undefined) { // && responseData.error == "unsupportedPattern") {
                                throw responseData.error;
                            }
                            //this.pattern = requestData.pattern;
                            /*
                            let pattern = this.patterns.filter(pattern => pattern.id == requestData.patternId);

                            if (pattern.length > 0) {
                                this.showPattern(pattern[0]);
                            }
                            */

                            const removeMeta = (object) => {
                                const obj = JSON.parse(JSON.stringify(object)); //{ ...object }; //

                                if (obj.hasOwnProperty("meta")) {
                                    delete obj.meta;
                                }

                                for (let item in obj) {
                                    if (typeof obj[item] === "object") { obj[item] = removeMeta(obj[item]); }
                                }

                                return obj;
                            };

                            let dataJSON = removeMeta({
                                items:    requestData.pattern.items,
                                kerf:     requestData.pattern.kerf,
                                order:    requestData.pattern.order,
                                v:        2,
                                vertical: requestData.pattern.vertical
                            });

                            let pattern = {
                                id:                requestData.patternId,
                                name:              requestData.pattern.name,
                                speciesTranslated: this.$t(requestData.pattern.species),
                                Du:                requestData.pattern.du,
                                updatedAt:         requestData.pattern.date,
                                dataJSON:          JSON.stringify(dataJSON)
                            }

                            this.showPattern(pattern);

                            this.length         = requestData.l;
                            this.minBoardLength = requestData.minBoardL;
                            this.curvature      = requestData.curvature;

                            /*
                            let graphData = responseData.data.sort((a, b) => {
                                    return a[0] < b[0] ? -1 : 1;
                                });

                            graphData.forEach(item => {
                                item[1] = parseFloat(item[1]).toFixed(1);
                            });
                            */

                            //this.$debug.log(responseData.tablesData);

                            this.tableData = {
                                noCurvature:  [],
                                minCurvature: [],
                                maxCurvature: []
                            },

                            responseData.tablesData.forEach(table => {
                                if (table.name == "noCurv") {
                                    this.tableData.noCurvature = table.data;
                                }
                                if (table.name == "minCurv") {
                                    this.tableData.minCurvature = table.data;
                                }
                                if (table.name == "maxCurv") {
                                    this.tableData.maxCurvature = table.data;
                                }
                            });

                            this.series = responseData.series;

                            this.calcTimestamp = new Date(response.data.task.createdAt).toLocaleDateString() + " " + new Date(response.data.task.createdAt).toLocaleTimeString();

                            this.drawChart();

                            this.calculatedTableData = [];

                            if (responseData.optimalPattern != undefined) {
                                let component  = this;
                                let boardsAmount = 0;
                                let outputVol = 0;

                                this.optimalDiam = responseData.optimalPattern.D;
                                this.optimalOutput = responseData.optimalPattern.output;

                                responseData.optimalPattern.dimensions.forEach((item, index) => {

                                    let size = item.split("-")[0].split("x");
                                    let len = item.split("-")[1].replace(",",".");
                                    let vol = (parseFloat(size[0])/1000) * (parseFloat(size[1])/1000) * parseFloat(len) * responseData.optimalPattern.amount[index];
                                    outputVol += vol;
                                    boardsAmount += responseData.optimalPattern.amount[index];

                                    component.calculatedTableData.push({
                                        size:       item.split("-")[0],
                                        length:     len,
                                        volume:     vol.toFixed(3),
                                        percent:    (vol / responseData.optimalPattern.logV * 100).toFixed(2).toString(),
                                        qty:        responseData.optimalPattern.amount[index]
                                    });
                                });

                                this.calculatedTableData.push({
                                    size:       "",
                                    length:     "",
                                    volume:     outputVol.toFixed(3).toString(),
                                    percent:    responseData.optimalPattern.output.toFixed(2).toString(),
                                    qty:        "(" + (boardsAmount).toString() + ")"
                                });
                                this.calculatedTableData.push({
                                    size:       "",
                                    length:     "",
                                    volume:     responseData.optimalPattern.dustVol.toFixed(3).toString(),
                                    percent:    (responseData.optimalPattern.dustVol / responseData.optimalPattern.logV * 100).toFixed(2).toString(),
                                    qty:        this.$t("sawdust")
                                });
                                this.calculatedTableData.push({
                                    size:       "",
                                    length:     "",
                                    volume:     responseData.optimalPattern.chipsVol.toFixed(3).toString(),
                                    percent:    (responseData.optimalPattern.chipsVol / responseData.optimalPattern.logV * 100).toFixed(2).toString(),
                                    qty:        this.$t("woodChips")
                                });
                                this.calculatedTableData.push({
                                    size:       "",
                                    length:     "",
                                    volume:     responseData.optimalPattern.logV.toFixed(3).toString(),
                                    percent:    "",
                                    qty:        this.$t("rawMaterials"),
                                });
                            }

                        }
                        this.loading.calculationResult = false;
                    })
                    .catch(err => {
                        this.$debug.error(err);

                        this.loading.calculationResult = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `DiamOptimization.vue -> getTaskResult: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            this.$debug.error(error);

                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (typeof err == "string") {
                            let errDescription = err == "unsupportedPattern" ? ". " + this.$t("unsupportedPatternInfo") : "";

                            //this.showMessageBox(this.$t("information"), this.$t(err) + errDescription);
                            if (err == "unsupportedPattern") {
                                this.showMessageBox(this.$t(err), this.$t("unsupportedPatternInfo"));
                            } else {
                                this.showMessageBox(this.$t("information"), this.$t(err) + errDescription);
                            }
                        } else if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("applicationError"));
                        }
                    });
            },

            /**
             * Загрузка поставов
             */
            loadPatterns () {
                this.loading.patterns = true;

                this.axios.get(`${this.$config.apiURL}patterns/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let patternsInfo = response.data.patterns;

                            this.patterns    = [];

                            patternsInfo.forEach((patternInfo) => {
                                let updatedTimestamp = new Date(patternInfo.updatedAt);

                                this.patterns.push({
                                    id:        patternInfo.id,
                                    species:   patternInfo.Species.Name,
                                    speciesTranslated: this.$t(patternInfo.Species.Name),
                                    name:      patternInfo.Name,
                                    Du:        patternInfo.Du,
                                    Dmin:      patternInfo.Dmin,
                                    Dmax:      patternInfo.Dmax,
                                    DLimitMin: patternInfo.DLimitMin,
                                    DLimitMax: patternInfo.DLimitMax,
                                    dataJSON:  patternInfo.DataJSON,
                                    updatedAt: updatedTimestamp.toLocaleString(),
                                    updatedAtTimestamp: Date.parse(updatedTimestamp),
                                    //visible:    patternInfo.visible
                                });

                                /*
                                let newDiameter = true;

                                component.diametersList.forEach(element => {
                                    if (element.title == patternInfo.Du) { newDiameter = false; }
                                });

                                if (newDiameter && patternInfo.Du !== null) {
                                    component.diametersList.push({
                                        id:    patternInfo.id,
                                        title: patternInfo.Du //.toString()
                                    });
                                }

                                if (component.speciesList.filter(species => species.title == patternInfo.Species.Name).length == 0) {
                                    component.speciesList.push({
                                        id:              patternInfo.Species.id,
                                        title:           patternInfo.Species.Name,
                                        titleTranslated: component.$t(patternInfo.Species.Name),
                                    });
                                }
                                */
                            });
                        }

                        this.loading.patterns = false;
                    })
                    .catch(err => {
                        this.$debug.error(err);

                        this.loading.patterns = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `DiamOptimization.vue -> loadPatterns: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            this.$debug.error(error);

                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData"));
                        }
                    });
            },

            /**
             * Загрузка списка пород
             */
            loadSpecies () {
                this.loading.species = true;

                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        this.loading.species = false;
                        this.speciesLoaded   = true;

                        if (response.data.status == "success") {
                            let speciesInfo = response.data.species

                            this.species = [];

                            speciesInfo.forEach((item) => {
                                if (item.Visible) {
                                    this.species.push({
                                        id:                item.id,
                                        species:           item.Name,
                                        speciesTranslated: this.$t(item.Name)
                                    });
                                }
                            });

                            this.species.sort((a, b) => a.speciesTranslated > b.speciesTranslated);
                        }
                    })
                    .catch(error => {
                        this.$debug.error(error);

                        this.loading.species = false;
                        this.speciesLoaded   = true;

                        if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " +this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData"));
                        }
                    });
            },

            // onChartHighlight (params) {
            //     this.$debug.log("onChartHighlight", params);
            // },

            /**
             * Печать графика
             */
            printChart () {
                let printChartOptions = { ...this.chartOptions };

                printChartOptions.legend.data = [ this.$t("noCurv"), this.$t("minCurv"), this.$t("maxCurv"), this.$t("avgCurv") ];
                printChartOptions.series[0].name = this.$t("noCurv");
                printChartOptions.series[1].name = this.$t("minCurv");
                printChartOptions.series[2].name = this.$t("maxCurv");
                printChartOptions.series[3].name = this.$t("avgCurv");

                this.$debug.log(printChartOptions);

                printChartOptions.animation = false;

                this.$refs.DiamPrintDialog.chartOptions    = printChartOptions;
                this.$refs.DiamPrintDialog.pattern         = this.pattern;
                this.$refs.DiamPrintDialog.selectedPattern = this.selectedPattern;
                this.$refs.DiamPrintDialog.diamsRange      = this.diamsRange;
                this.$refs.DiamPrintDialog.optimalDiam     = this.optimalDiam;
                this.$refs.DiamPrintDialog.logLength       = this.length;
                this.$refs.DiamPrintDialog.curvature       = this.curvature;
                this.$refs.DiamPrintDialog.avgTaper        = this.autoTaper ? null : this.taper;
                this.$refs.DiamPrintDialog.calcTimestamp   = this.calcTimestamp;
                //this.$refs.DiamPrintDialog.tableData       = this.tableData.minCurvature.filter(item => parseInt(item.D) == parseInt(this.chartOptions.series[3].data[this.chartOptions.series[3].markLine.data[2].xAxis][0]));
                this.$refs.DiamPrintDialog.tableData       = this.calculatedTableData;
                this.$refs.DiamPrintDialog.tableHeader     = this.calculatedTableHeader;
                this.$refs.DiamPrintDialog.dialog          = true;
            },

            /**
             * Отображение информации об ошибке
             *
             * @param {object} responseData Полученные от оптимизатора данные
             */
            /*
            showError (responseData) {
                if (responseData.error) {
                    //let optimizer = this;
                    let line = responseData.line ? responseData.line : [];

                    switch (responseData.error.type) {
                        case "VolumeTableDataNotFound":
                        case "VolumeError":
                            this.$refs.CalcErrorDialog.message = "errors.volumeTableDataNotFound";
                            break;
                        case "NoSawDevices":
                            this.$refs.CalcErrorDialog.message = "errors.noSawDevices";
                            break;
                        case "NoOptimalPattern":
                            this.$refs.CalcErrorDialog.message = "errors.noOptimalPattern";
                            break;
                        case "EmptyPatterns":
                            this.$refs.CalcErrorDialog.message = "errors.emptyPatterns";
                            break;
                        case "ErrorMethod":
                            this.$refs.CalcErrorDialog.message = "errors.errorMethod";
                            break;
                        case "FbsDiamMaxLog":
                            this.$refs.CalcErrorDialog.message = "errors.fbsDiamMaxLog";
                    }

                    let hideLine = true;
                    let num = 0;
                    line.forEach((equipment) => {
                        equipment.alert = ++num == responseData.error.deviceNum;
                        hideLine = equipment.alert ? false : hideLine;

                        switch (equipment.name) {
                            case "circularSaw":
                                equipment.image = "img/equipment/circular.webp";
                                break;
                            case "edgeTrimmer":
                                equipment.image = "img/equipment/edge_trimmer.webp";
                                break;
                            case "fbs":
                                equipment.image = "img/equipment/fbs.webp";
                                break;
                            case "multiSaw":
                                equipment.image = "img/equipment/multisaw.webp";
                                break
                            case "profilingMachine":
                                equipment.image = "img/equipment/profiling.webp";
                                break;
                            case "rotateAndPositioningDev":
                                equipment.image = "img/equipment/turn.webp";
                                break;
                            case "scanner":
                                equipment.image = "img/equipment/scanner.webp";
                        }
                    });

                    this.$refs.CalcErrorDialog.hideLine = hideLine;
                    this.$refs.CalcErrorDialog.line     = line;
                    this.$refs.CalcErrorDialog.dialog   = true;
                }
            },
            */

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Отображение постава
             *
             * @param {object} data Информация о поставе
             */
            showPattern (data) {
                /*
                $("#pattern_preview").empty();
                let pattern = new Pattern(JSON.parse(data.dataJSON), $("#pattern_preview1"));
                */
                this.selectedPattern = data;
                this.optimalDiam = 0;
                this.optimalOutput = 0;
                localStorage.patternsLibCurrent = JSON.stringify(this.selectedPattern); //data);
                this.pattern = JSON.parse(data.dataJSON); //data;
            },

            /**
             * Обработчик нажатия кнопки истории
             */
            tasksHistoryClick () {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.TasksHistoryDialog.id",
                    (val) => {
                        if (val) { this.getTaskResult(val); }
                    }
                );

                this.$refs.TasksHistoryDialog.id       = null;
                this.$refs.TasksHistoryDialog.taskType = 2;
                this.$refs.TasksHistoryDialog.dialog   = true;
            },

        }
    }
</script>

<style lang="sass" scoped>
    .chart
        height: calc(50dvh - 100px) !important
        z-index: 10

    .container.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100dvh - 96px)
        .v-scrollable-chart
            overflow-y: auto
            max-height: calc(50dvh - 48px)
        .v-scrollable-table
            overflow-y: auto
            max-height: calc(50dvh - 54px)

    .flex-card
        display: flex
        flex-direction: column
        .v-toolbar
            flex: 0

    .pattern
        width: 350px
        height: 350px
        &-container
            box-sizing: border-box
            /* border: 1px solid #aaa */
            display: inline-block
            padding: 8px
            width: 370px
            height: 370px
            margin: 0 auto

    .columnChart
        height: 300px

    .simple-data-table
        border-collapse: collapse
        thead
            tr
                th
                    position: sticky
                    top: 0
                    border-bottom: solid #ccc
                    font-weight: bold
                    padding: 5px 2px
        tbody
            tr
                td
                    border-bottom: solid 1px #ccc
                    padding: 5px 2px

    .application
        &.theme--dark
            .simple-data-table
                border-collapse: collapse
                thead
                    tr
                        th
                            background-color: #424242
        &.theme--light
            .simple-data-table
                border-collapse: collapse
                thead
                    tr
                        th
                            background-color: #fff

</style>
